module.exports = __webpack_public_path__ + "static/media/muscleSlap.9c890aa0.gif";